import { ChangeDetectionStrategy, Component, HostListener, Input, NgModule, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ChipModule } from '@commons/chip/chip.component';
import { TypeContratModule } from '@commons/pole-emploi/type-contrat.pipe';
import { FeaturesRoutingEnum } from '@features/features-routing.enum';
import { PoleEmploiJobOrigine } from '@models/jobs/job-origine';
import { PoleEmploiJob, PoleEmploiOrigin } from '@models/jobs/job-preview';
import { Store } from '@ngxs/store';
import { SharedModule } from '@shared/shared.module';
import { VisitedUrlState } from '@stores/visited-url/visited-url.state';
import { trackEventWithAtInternet } from '@wizbii/tracking';
import { BehaviorSubject, Observable } from 'rxjs';

@Component({
  selector: 'app-job-list-card',
  templateUrl: './job-list-card.component.html',
  styleUrls: ['./job-list-card.component.scss', './job-list-card-content.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class JobListCardComponent implements OnInit, OnDestroy {
  get elm_id(): string {
    return this.elmId ?? this._id;
  }

  get trackEventCategory(): string {
    return this.origin === PoleEmploiOrigin.JOB ? 'Emploi' : PoleEmploiOrigin.SUMMER_JOB ? "Job d'éte" : 'Job étudiant';
  }

  get ariaLabel(): string {
    return `Consulter l'offre d'emploi ${this.job?.intitule} ${this.job?.typeContrat} ${this.job?.dureeTravailLibelleConverti} proposée par ${this.job?.entreprise?.nom} située à ${this.job?.lieuTravail?.libelle} `;
  }
  private static Counter = 0;

  @Input() job!: PoleEmploiJob;
  @Input() elmId!: string;
  @Input() origin!: PoleEmploiOrigin;

  private readonly _id = `wzb-job-list-card-${++JobListCardComponent.Counter}`;

  FeaturesRoutingEnum = FeaturesRoutingEnum;
  PoleEmploiJobOrigine = PoleEmploiJobOrigine;
  PoleEmploiOrigin = PoleEmploiOrigin;
  trackEvent = trackEventWithAtInternet;

  routerLink$ = new BehaviorSubject<string[]>([]);
  isVisited$!: Observable<boolean>;

  constructor(readonly router: Router, readonly route: ActivatedRoute, private readonly store: Store) {}

  @HostListener('keydown.enter', ['$event.target'])
  @HostListener('click', ['$event.target'])
  doRegister(target: any): void {
    if (['BUTTON', 'A'].indexOf(target.tagName) !== -1) {
      return;
    }

    this.router.navigate(
      [
        '/',
        this.origin === PoleEmploiOrigin.JOB
          ? FeaturesRoutingEnum.Jobs
          : this.origin === PoleEmploiOrigin.SUMMER_JOB
          ? FeaturesRoutingEnum.SummerJobs
          : FeaturesRoutingEnum.StudentJobs,
        this.job?.id,
      ],
      {
        state: { queryParams: this.route.snapshot.queryParams },
      }
    );
    this.trackEvent({
      category: this.trackEventCategory,
      action: 'Click Offre',
      label: `${this.job.typeContrat} - ${this.job.lieuTravail?.libelle}`,
      type: 'navigation',
    });
  }

  ngOnInit(): void {
    const urlOrigin =
      this.origin === PoleEmploiOrigin.JOB
        ? FeaturesRoutingEnum.Jobs
        : this.origin === PoleEmploiOrigin.SUMMER_JOB
        ? FeaturesRoutingEnum.SummerJobs
        : FeaturesRoutingEnum.StudentJobs;

    this.routerLink$.next(['/', urlOrigin, this.job?.id]);

    this.isVisited$ = this.store.select(VisitedUrlState.isUrlVisited(`/${urlOrigin}/${this.job?.id}`));
  }

  ngOnDestroy(): void {
    this.routerLink$.complete();
  }
}

@NgModule({
  imports: [ChipModule, TypeContratModule, SharedModule],
  declarations: [JobListCardComponent],
  exports: [JobListCardComponent],
})
export class JobListCardModule {}
